(function () {
    'use strict';
    angular
        .module('jotApp')
        .factory('Queue', Queue);

    Queue.$inject = ['$resource', 'DateUtils'];

    function Queue($resource, DateUtils) {
        var resourceUrl = 'api/queues/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'forceComplet' : {
                url: 'api/queues/forceComplet',
                method: 'GET'
            },
            'stopCron' : {
                url: 'api/queues/stopCron',
                method: 'GET'
            },
            'create' : {method: 'PUT'},
            'checkExpired' : {method: 'GET'},
            'getByAlias' : {
                url: 'api/queues/alias',
                method: 'GET',
                isArray: true
            },
            'countByAlias' : {
                url: 'api/queues/countAlias',
                method: 'GET',
                isArray: true
            },
            'getGroups' : {
                url: 'api/queues/groupList',
                method: 'GET',
                isArray: true
            }
        });
    }
})();
